var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-notification',{class:_vm.$style.loadingContainer,attrs:{"closable":false}},[_c('b-loading',{attrs:{"is-full-page":false,"active":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }